import $ from "jquery";
window.$ = window.jQuery = $;

import select2 from 'select2';
select2() // init

require('flatpickr')

